// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__EL52K","col":"styles_col__Xddlc"};